import React from "react";
import { PlaneTakeoff } from "lucide-react";
import { esHoy } from "@/lib/ocio";

export const limpiarTerminal = (t) => String(t || "").trim().replace(/^terminal\s*/i, "").replace(/^t(?=\d)/i, "");
export const textoEmbarque = (p) => [p.terminal && `Terminal ${limpiarTerminal(p.terminal)}`, p.puerta && `Puerta ${String(p.puerta).trim().replace(/^puerta\s*/i, "")}`].filter(Boolean).join(" · ");

// Terminal y puerta destacadas el mismo día del viaje (solo si constan en el documento).
export const Embarque = ({ p }) => {
  const txt = textoEmbarque(p);
  if (!esHoy(p) || !txt) return null;
  return (
    <div className="mt-3 rounded-xl bg-[#1C2421] text-white p-3" data-testid={`ocio-embarque-${p.id}`}>
      <p className="flex items-center gap-2 font-heading text-xl font-bold"><PlaneTakeoff size={22} /> {txt}</p>
      <p className="text-sm text-white/80 mt-1">La puerta de embarque puede cambiar. Compruébala en la información de la aerolínea o del aeropuerto.</p>
    </div>
  );
};
